var map = {
	"./bh-ico.svg": 783,
	"./bonus-ico.svg": 784,
	"./deposit-ico.svg": 785,
	"./deposit-ico.webp": 1726,
	"./edit-icon.svg": 786,
	"./fb-ico.svg": 787,
	"./mall-ico.svg": 788,
	"./msg-ico.svg": 789,
	"./pi-ico.svg": 790,
	"./rf-ico.svg": 791,
	"./rh-ico.svg": 792,
	"./th-ico.svg": 793,
	"./vip-ico.svg": 794,
	"./withdrawal-ico.svg": 795,
	"./withdrawal-ico.webp": 1727,
	"./wl-ico.svg": 796
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1725;